import React, { useEffect, useState } from "react";
import BaseURL from "../../../assets/utils/baseUrl";
import MUIDataTable from "mui-datatables";
import { Button, Footer, HeaderAdmin } from "../../../components";
import { TextField, Select, MenuItem, InputLabel, FormControl } from "@material-ui/core";
import { Loader } from "../../../assets";
import { Link } from "react-router-dom";

function KelolaJabatan({ setToken }) {
  const [jabatan, setJabatan] = useState([]);
  const [bidang, setBidang] = useState([]);
  const [modal, setModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(true);
  const [popUp, setPopUp] = useState(false);
  const [success, setSuccess] = useState(true);
  const [load, setLoad] = useState(true);
  const [loading, setLoading] = useState(true);
  const [alertNamaJabatan, setAlertNamaJabatan] = useState(false);
  const [alertIdBidang, setAlertIdBidang] = useState(false);
  const [formData, setFormData] = useState({
    nama_jabatan: "",
    id_bidang: "",
  });
  const [id, setId] = useState("");
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    setLoading(true);
    const getDataJabatan = async () => {
      await fetch(BaseURL + "index.php/api/Jabatan")
        .then((res) => res.json())
        .then((data) => {
          setJabatan(data.data);
          setLoading(false);
        });
    };
    const getDataBidang = async () => {
      await fetch(BaseURL + "index.php/api/bidang")
        .then((res) => res.json())
        .then((data) => {
          setBidang(data.data);
          setLoading(false);
        });
    };
    getDataJabatan();
    getDataBidang();
  }, [load]);

  useEffect(() => {
    let tablesData = [];

    if (jabatan.length > 0) {
      for (let i = 0; i < jabatan.length; i++) {
        tablesData.push({
          nama_jabatan: jabatan[i].nama_jabatan,
          bidang: jabatan[i].nama_bidang,
          tanggal_post: jabatan[i].created_date,
          opsi: jabatan[i].id_jabatan,
        });
      }
    }
    setTableData(tablesData);
  }, [jabatan]);

  const columns = [
    {
      name: "nama_jabatan",
      label: "Nama Jabatan",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return <div style={{ width: 200 }}>{value}</div>;
        },
      },
    },
    {
      name: "bidang",
      label: "Bidang",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "tanggal_post",
      label: "Tanggal Post",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return <div style={{ width: 100 }}>{value}</div>;
        },
      },
    },
    {
      name: "opsi",
      label: "Opsi",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div className="tooltip btn-hapus-row" onClick={() => hapus(value)}>
                <i className="fas fa-trash-alt"></i>
                <span className="tooltiptext">Hapus</span>
              </div>
              <div
                className="tooltip btn-edit-row"
                onClick={() => {
                  setUpdateModal(true);
                  openUpdateModal(value);
                }}
              >
                <i className="fas fa-edit"></i>
                <span className="tooltiptext">Update</span>
              </div>
            </div>
          );
        },
      },
    },
  ];

  const options = {
    sort: true,
    filter: false,
    download: false,
    print: false,
    selectableRows: false,
  };

  const tambah = () => {
    if (formData.nama_jabatan == "") {
      setAlertNamaJabatan(true);
    } else {
      setAlertNamaJabatan(false);
    }

    if (formData.id_bidang == "") {
      setAlertIdBidang(true);
    } else {
      setAlertIdBidang(false);
    }

    if (formData.nama_jabatan !== "" && formData.id_bidang !== "") {
      const data = new FormData();
      let today = new Date();
      let date = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
      data.append("request", "post");
      data.append("nama_jabatan", formData.nama_jabatan);
      data.append("id_bidang", formData.id_bidang);
      data.append("id_user", localStorage.getItem("id"));
      data.append("created_date", date);

      try {
        fetch(BaseURL + "index.php/api/jabatan", {
          method: "POST",
          body: data,
        })
          .then((response) => response.json())
          .then((data) => {
            setFormData({
              nama_jabatan: "",
              id_bidang: "",
            });
            setLoad(!load);
            setModal(false);
            setUpdateModal(false);
            if (data.status) {
              setSuccess(true);
            } else {
              setSuccess(false);
            }
            setPopUp(true);
          })
          .catch((error) => console.log("Gagal: ", error));
      } catch (error) {
        alert("Terjadi kesalahan pada sistem");
        console.log(error);
      }
    }
  };

  const hapus = ($id) => {
    try {
      fetch(BaseURL + "index.php/api/jabatan/" + $id, {
        method: "DELETE",
      })
        .then((response) => response.json())
        .then((data) => {
          setLoad(!load);
          if (data.status) {
            setSuccess(true);
          } else {
            setSuccess(false);
          }
          setPopUp(true);
        })
        .catch((error) => console.log("Gagal: ", error));
    } catch (error) {
      alert("Terjadi kesalahan pada sistem");
      console.log(error);
    }
  };

  const openUpdateModal = ($id) => {
    const getDataUpdate = async () => {
      await fetch(BaseURL + "index.php/api/jabatan?id=" + $id)
        .then((res) => res.json())
        .then((data) => {
          setFormData({
            ...formData,
            nama_jabatan: data.data[0].nama_jabatan,
            id_bidang: data.data[0].id_bidang,
          });
          setId($id);
          setModal(true);
        });
    };
    getDataUpdate();
  };

  const update = () => {
    if (formData.nama_jabatan == "") {
      setAlertNamaJabatan(true);
    } else {
      setAlertNamaJabatan(false);
    }

    if (formData.id_bidang == "") {
      setAlertIdBidang(true);
    } else {
      setAlertIdBidang(false);
    }

    if (formData.nama_jabatan !== "" && formData.id_bidang !== "") {
      const data = new FormData();
      let today = new Date();
      let date = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
      data.append("request", "put");
      data.append("id_jabatan", id);
      data.append("nama_jabatan", formData.nama_jabatan);
      data.append("id_bidang", formData.id_bidang);
      data.append("id_user", localStorage.getItem("id"));
      data.append("created_date", date);
      data.append("updated_date", date);

      try {
        fetch(BaseURL + "index.php/api/jabatan", {
          method: "POST",
          body: data,
        })
          .then((response) => response.json())
          .then((data) => {
            setFormData({
              nama_jabatan: "",
              id_bidang: "",
            });
            setLoad(!load);
            setModal(false);
            setUpdateModal(false);
            if (data.status) {
              setSuccess(true);
            } else {
              setSuccess(false);
            }
            setPopUp(true);
          })
          .catch((error) => console.log("Gagal: ", error));
      } catch (error) {
        alert("Terjadi kesalahan pada sistem");
        console.log(error);
      }
    }
  };

  return (
    <div className="page">
      <HeaderAdmin title="Kelola Jabatan" setToken={(e) => setToken(e)} />
      <div className="main-admin">
        <div className="container-admin">
          <div style={{ height: 50 }} />
          <div style={{ display: "flex" }}>
            <Link to="/admin/kelola-pejabat">
              <Button title={<i class="fas fa-arrow-left"></i>} type="danger" />
            </Link>
            <div style={{ width: 10 }}></div>
            <Button
              title="Tambah Jabatan"
              type="primary"
              onClick={() => {
                setUpdateModal(false);
                setModal(true);
              }}
            />
            <div style={{ width: 10 }}></div>
            <Link to="/admin/kelola-bidang">
              <Button title="Kelola Bidang" type="primary" />
            </Link>
          </div>
          <div style={{ height: 10 }}></div>
          {loading ? (
            <div className="loader">
              <img src={Loader}></img>
            </div>
          ) : (
            <MUIDataTable title={"Daftar Jabatan"} data={tableData} columns={columns} options={options} download={false} className="table" />
          )}
        </div>
      </div>

      <Footer />

      {/* modal */}
      <div className={modal ? "darker-bg-admin" : "darker-bg-admin hide"}>
        {/* form */}
        <div className="modal-admin">
          <div className="form-admin">
            <TextField id="nama_jabatan" label="Nama Jabatan" variant="outlined" style={{ marginTop: 10, marginBottom: 10 }} onChange={(e) => setFormData({ ...formData, nama_jabatan: e.target.value })} value={formData.nama_jabatan} />
            {alertNamaJabatan && <div className="danger-alert">Nama Jabatan tidak boleh kosong</div>}

            {/* <FormControl style={{ marginTop: 10, marginBottom: 10 }}> */}
            <InputLabel id="bidang-select-label">bidang</InputLabel>
            <Select labelId="bidang-select-label" id="bidang" value={formData.id_bidang} onChange={(e) => setFormData({ ...formData, id_bidang: e.target.value })}>
              {bidang.length > 0 &&
                bidang.map((item, idx) => {
                  return (
                    <MenuItem value={item.id_bidang} key={idx}>
                      {item.nama_bidang}
                    </MenuItem>
                  );
                })}
            </Select>
            {alertIdBidang && <div className="danger-alert">Pilih bidang</div>}
            <span className="file-name">(Jika bidang tidak tersedia, tambahkan di halaman Kelola Bidang)</span>
          </div>

          <div style={{ height: 30 }}></div>

          <div className="form-option">
            <Button
              title={updateModal ? "Update" : "Tambah"}
              type="primary"
              onClick={() => {
                if (updateModal) {
                  update();
                } else {
                  tambah();
                }
              }}
            />
            <div style={{ width: 10 }}></div>
            <Button
              title="Batal"
              type="danger"
              onClick={() => {
                setModal(false);
                setUpdateModal(false);
                setFormData({
                  nama_jabatan: "",
                  id_bidang: "",
                });
                setAlertNamaJabatan(false);
                setAlertIdBidang(false);
              }}
            />
          </div>
        </div>
      </div>

      {/* message pop up */}
      <div className={popUp ? "darker-bg-admin" : "darker-bg-admin hide"}>
        <div className="pop-up-admin">
          <i className={success ? "fas fa-check-circle pop-up-logo" : "fas fa-times-circle pop-up-logo failed-pop-up"}></i>
          {success ? <p>Berhasil</p> : <p className={success ? "" : "failed-pop-up"}>Gagal</p>}
          <div style={{ height: 20 }}></div>
          <Button
            title="Tutup"
            type="primary"
            onClick={() => {
              setAlertNamaJabatan(false);
              setAlertIdBidang(false);
              setPopUp(false);
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default KelolaJabatan;
